import type { Entity, ServerMessage, WorldMap } from './protocol';
import type { RoomContent } from './content';
import type { Member } from './identity';

/** Pure presentation store. A reconnect always clears the prior epoch. */
export class ClientState {
  epoch = '';
  selfId = '';
  tick = 0;
  private stateTick = -1;
  map: WorldMap | null = null;
  entities = new Map<string, Entity>();
  content: RoomContent | null = null;
  permissions = { canBuild: false, canManage: false };
  members: Member[] = [];
  reset(): void { this.epoch = ''; this.selfId = ''; this.tick = 0; this.stateTick = -1; this.map = null; this.content = null; this.entities.clear(); this.permissions = { canBuild: false, canManage: false }; this.members = []; }
  apply(message: ServerMessage): boolean {
    if (message.type === 'snapshot') {
      if ((this.epoch && (message.epoch === this.epoch || message.roomId !== this.content?.room.id || message.selfId !== this.selfId || message.tick < this.tick || message.content.room.revision < this.content.room.revision)) || message.content.room.id !== message.roomId || !message.entities.some(e => e.id === message.selfId) || new Set(message.entities.map(e => e.id)).size !== message.entities.length) return false;
      this.epoch = message.epoch; this.selfId = message.selfId; this.tick = message.tick; this.map = message.map;
      this.content = message.content;
      this.permissions = message.permissions; this.members = message.members;
      this.stateTick = message.tick; this.entities = new Map(message.entities.map(e => [e.id, e])); return true;
    }
    if (!('epoch' in message) || message.epoch !== this.epoch || !('tick' in message) || message.tick < this.tick) return false;
    if (message.type === 'state' && (message.tick <= this.stateTick || !message.entities.some(e => e.id === this.selfId) || new Set(message.entities.map(e => e.id)).size !== message.entities.length)) return false;
    if (message.type === 'contents' && (message.content.room.id !== this.content?.room.id || message.content.room.revision < this.content.room.revision)) return false;
    this.tick = message.tick;
    switch (message.type) {
      case 'presence': this.members = message.members; return true;
      case 'contents':
        if (message.content.room.environmentData?.packageHash !== this.content?.room.environmentData?.packageHash && message.content.room.environmentData) this.map = { ...message.content.room.environmentData.map, spawn: { ...message.content.room.settings.spawn } };
        this.content = message.content;
        if (this.map) {
          const spawn = message.content.room.settings.spawn;
          if (this.map.spawn.x !== spawn.x || this.map.spawn.y !== spawn.y || this.map.spawn.z !== spawn.z) this.map = { ...this.map, spawn: { ...spawn } };
        }
        return true;
      case 'state': this.stateTick = message.tick; this.entities = new Map(message.entities.map(e => [e.id, e])); return true;
      case 'spawn': case 'enter': this.entities.set(message.entity.id, message.entity); return true;
      case 'despawn': case 'leave': this.entities.delete(message.id); return true;
      default: return false;
    }
  }
}
